import { render, staticRenderFns } from "./PassRecoveryConfirm.vue?vue&type=template&id=5ddd872e&scoped=true"
import script from "./PassRecoveryConfirm.vue?vue&type=script&lang=js"
export * from "./PassRecoveryConfirm.vue?vue&type=script&lang=js"
import style0 from "./PassRecoveryConfirm.vue?vue&type=style&index=0&id=5ddd872e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd872e",
  null
  
)

export default component.exports